import { IState } from "./types";

export const FETCH_LOGO = "businessSettings/fetchLogo";
export const FETCH_LOGO_REQUEST = "businessSettings/fetchLogoRequest";
export const FETCH_LOGO_SUCCESS = "businessSettings/fetchLogoSuccess";
export const FETCH_LOGO_ERROR = "businessSettings/fetchLogoError";

export const UPLOAD_LOGO = "businessSettings/uploadLogo";
export const UPLOAD_LOGO_REQUEST = "businessSettings/uploadLogoRequest";
export const UPLOAD_LOGO_SUCCESS = "businessSettings/uploadLogoSuccess";
export const UPLOAD_LOGO_ERROR = "businessSettings/uploadLogoError";

export const DELETE_LOGO = "businessSettings/deleteLogo";
export const DELETE_LOGO_REQUEST = "businessSettings/deleteLogoRequest";
export const DELETE_LOGO_SUCCESS = "businessSettings/deleteLogoSuccess";
export const DELETE_LOGO_ERROR = "businessSettings/deleteLogoError";

export const initialState: IState = {
  logoUrl: undefined,
  dimensionWarnings: undefined,
  isFetching: false,
  isUploading: false,
  isDeleting: false,
  error: undefined,
};
